// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/companies/:company_id/free_trial/developers" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFreeTrialDevelopersCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdFreeTrialDevelopersProps, PostFreeTrialDeveloperResult } from "./types";

export const postFreeTrialDeveloper = reactQueryMutationAdapter(
  companiesCompanyIdFreeTrialDevelopersCacheKeys,
  (props: PostCompaniesCompanyIdFreeTrialDevelopersProps): Promise<PostFreeTrialDeveloperResult> => {
    return fetch(`/companies/${props.companyId}/free_trial/developers`, "POST", props.body, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
